// @ts-nocheck
import { post } from "@insite/client-framework/Services/ApiService";
import { SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";

interface SubmitContactFormApiParameterCustom extends SubmitContactUsFormApiParameter {
    zipCode?: string;
}

const emailsUrl = "api/v1/email";

export function submitContactFormCustom(parameter: SubmitContactFormApiParameterCustom) {
    let zipCodeParameter = <string | undefined>"";
    if (typeof parameter.zipCode !== "undefined") {
        zipCodeParameter = `?zipCode=${parameter.zipCode}`;
    }
    return post<SubmitContactUsFormApiParameter, void>(`${emailsUrl}/contactUs${zipCodeParameter}`, parameter);
}
